import SearchIcon from "assets/icons/SearchIcon";
import XIcon from "assets/icons/XIcon";
import { ChangeEvent } from "react";

import styles from "./style.module.scss";

const ContentHeader = ({
  title,
  isLoading,
  searchText,
  showClearButton,
  onClear,
  onChange,
}: ContentHeaderProps) => {
  return (
    <div className={styles.contentHeader}>
      <div className={styles.searchIcon}>
        <SearchIcon />
      </div>
      <input
        type="search"
        placeholder={`Search ${title}`}
        onChange={onChange}
        value={searchText}
        className={styles.searchInput}
      />
      {showClearButton && (
        <div className={styles.closeSearchBtn} onClick={onClear}>
          <XIcon />
        </div>
      )}
      {isLoading && <div className={styles.loaderBar}></div>}
    </div>
  );
};

export default ContentHeader;

interface ContentHeaderProps {
  title: string;
  searchText: string;
  isLoading: boolean;
  showClearButton: boolean;
  onClear: () => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}
